import React from 'react';
import { TechnicalError } from '@algoan/deep-dive/technical-error';
import { connect } from 'react-redux';
import { logout } from '@algoan/dashboard/store/thunks';
import { monitoring } from '@algoan/dashboard/utils';

interface InternalErrorBoundaryProps {
  children: React.ReactNode;
  logout: () => void;
}

interface InternalErrorBoundaryState {
  hasError: boolean;
}

class InternalErrorBoundary extends React.Component<InternalErrorBoundaryProps, InternalErrorBoundaryState> {
  constructor(props: InternalErrorBoundaryProps) {
    super(props);

    this.state = { hasError: false };
  }
  static getDerivedStateFromError(): InternalErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error): void {
    // We log all technical errors
    monitoring.logError({ error });
  }

  render(): React.ReactNode {
    if (this.state.hasError) {
      return <TechnicalError onButtonClick={this.props.logout} />;
    }

    return this.props.children;
  }
}

export const ErrorBoundary = connect(null, { logout })(InternalErrorBoundary);
